export type CommissionKpiResult = "BELOW" | "REACHED" | "EXCEEDED";
export type CommissionStatus = "LOCKED" | "UNLOCKED_FOR_EDIT";

export const commissionKpiResultTrans: Record<
  CommissionKpiResult,
  { label: string; color: string; bgcolor: string }
> = {
  BELOW: { label: "Chưa đạt", color: "#b42318", bgcolor: "#fef3f2" },
  REACHED: { label: "Đạt", color: "#175cd3", bgcolor: "#eff8ff" },
  EXCEEDED: { label: "Vượt", color: "#027a48", bgcolor: "#d1fadf" },
};

export interface CommissionRow {
  commissionId?: number;
  staffId: number;
  staffName: string;
  baseSalary: number;
  revenueCollected: number;
  targetRevenue: number;
  rateBelowKpi: number;
  rateReachKpi: number;
  rateExceedKpi: number;
  kpiResult: CommissionKpiResult;
  personalCommissionAmount: number;
  teamRevenueCollected: number;
  teamTargetRevenue: number;
  teamBonusRate: number;
  teamCommissionAmount: number;
  totalIncomeAmount: number;
  status: CommissionStatus;
  lockedAt?: number;
  lockedBy?: string;
  lastUnlockNote?: string;
  lastUnlockAt?: number;
  lastUnlockBy?: string;
}

export interface CommissionMonthlyData {
  isLocked: boolean;
  isUnlockedForEdit: boolean;
  rows: CommissionRow[];
  onlyMine: boolean;
}
